import {
  put, takeLatest, takeEvery, select, all, call,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import _ from 'lodash';
import history from 'app/routes/history';
import { paymentSchema, paymentListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import {
  createPaymentCollection,
  getAllPaymentCollections,
} from 'app/ducks/paymentCollections/actions';

import { sagaActions, getPayment } from 'app/ducks/payments/actions';
import { PaymentsActionTypes as types } from 'app/ducks/payments/types';

function* createPaymentSaga(action): any {
  let teamMemberIds = [];
  const { payload } = action;
  teamMemberIds = action.payload.teamMemberIds;

  delete payload.teamMemberIds;
  yield put(sagaActions.createPaymentPending(payload));
  const [error, response] = yield (yield TeammoApi(yield select())).organisationPaymentRequests.create(
    payload,
  );
  if (response) {
    // console.log(response);
    // if (!_.isEmpty(teamMemberIds)) {
    //   let consumerId;
    //   yield all(
    //     teamMemberIds.map((teamMemberId) => call(function* () {
    //       consumerId = yield select(
    //         (state) => state.teamMembers.teamMembersById[teamMemberId].consumer.id,
    //       );
    //       const teamMemberData = {
    //         payment: {
    //           id: response.id,
    //         },
    //         teamMember: {
    //           id: teamMemberId,
    //         },
    //         consumer: {
    //           id: consumerId,
    //         },
    //       };
    //       const actionSend = yield createPaymentCollection(teamMemberData);
    //       yield put(actionSend);
    //       return teamMemberData;
    //     })),
    //   );
    // }
    const normalizedResponse = normalize(response, paymentSchema);
    // yield put(yield getPayment(response.data.id));
    // yield put(yield getAllPaymentCollections(action.payload));
    yield put(sagaActions.createPaymentSuccess(normalizedResponse));
    setTimeout(() => {
      history.push(`/payments/segments/requests/detail/${response.data.id}`);
    }, 1000);
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createPaymentFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updatePaymentSaga(action): any {
  yield put(sagaActions.updatePaymentPending(action.payload));
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationPaymentRequests.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, paymentSchema);

    yield put(sagaActions.updatePaymentSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updatePaymentFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getPaymentSaga(action): any {
  yield put(sagaActions.getPaymentPending());
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationPaymentRequests.show(action.payload);
  // console.log(response);

  if (response) {
    const normalizedResponse = normalize(response, paymentSchema);
    yield all([
      put(sagaActions.getPaymentSuccess(normalizedResponse)),
      put(yield getAllPaymentCollections(action.payload)),
    ]);

    return normalizedResponse.entities.payments[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getPaymentFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllPaymentsSaga(action): any {
  yield put(
    sagaActions.getAllPaymentsPending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.payments.pagination))
    : action.payload.pagination;

  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationPaymentRequests.list(paginationObject);
  if (response) {
    const normalizedResponse = normalize(response, paymentListSchema);

    yield put(
      sagaActions.getAllPaymentsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllPaymentsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createPaymentSagaWatcher(): any {
  yield takeLatest(types.CREATE_PAYMENT_REQUESTED, createPaymentSaga);
}

function* updatePaymentSagaWatcher(): any {
  yield takeLatest(types.UPDATE_PAYMENT_REQUESTED, updatePaymentSaga);
}

function* getPaymentSagaWatcher(): any {
  yield takeEvery(types.GET_PAYMENT_REQUESTED, getPaymentSaga);
}

function* getAllPaymentsSagaWatcher(): any {
  yield takeEvery(types.GET_ALL_PAYMENTS_REQUESTED, getAllPaymentsSaga);
}

export default function* root(): any {
  yield all([
    createPaymentSagaWatcher(),
    updatePaymentSagaWatcher(),
    getPaymentSagaWatcher(),
    getAllPaymentsSagaWatcher(),
  ]);
}
